import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tags: {
    [BillingMode.Stripe]: 'Gebühr von der Zahlungsmethode',
    [BillingMode.InternalInvoicing]: 'Gebühr aus Verkäufen',
    active: 'Aktiv',
    on_trial: 'In der Testphase',
    launch_pending: 'Bis zur Markteinführung auf Eis gelegt',
    billing_disabled: 'Abrechnung deaktiviert',
    on_grace_period: 'Zur tilgungsfreien Zeit',
    past_due: 'Überfällig',
    cancelled: 'Abgesagt',
  },
};
